export const dashboardColumnData = [{
  accessor: 'origin',
  Header: 'Application Name',
  hidden: false
}, {
  accessor: 'appType',
  Header: 'Application Type',
  hidden: false
}, {
  accessor: 'originRiskCategory',
  Header: 'Application Risk Category',
  hidden: false
}, {
  accessor: 'originRiskScore',
  Header: 'Application Risk Score',
  hidden: false
}, {
  accessor: 'users',
  Header: 'Users',
  hidden: false
}, {
  accessor: 'groups',
  Header: 'Groups',
  hidden: false
}, {
  accessor: 'roles',
  Header: 'Roles',
  hidden: false
}, {
  accessor: 'resources',
  Header: 'Resources',
  hidden: false
}];
export const drillColumnData = [{
  accessor: 'envName',
  Header: 'Environment',
  hidden: false
}, {
  accessor: 'originRiskCategory',
  Header: 'Environment Risk Category',
  hidden: false
}, {
  accessor: 'originRiskScore',
  Header: 'Environment Risk Score',
  hidden: false
}, {
  accessor: 'users',
  Header: 'Users',
  hidden: false
}, {
  accessor: 'groups',
  Header: 'Groups',
  hidden: false
}, {
  accessor: 'roles',
  Header: 'Roles',
  hidden: false
}, {
  accessor: 'resources',
  Header: 'Resources',
  hidden: false
}];